import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { PLAN_INTERVALS } from '../../../businessLogic/PlansData';
import { Color } from '../../../config/Color';
import { useAppStore } from '../../../store/Store';
import { PricingSelector } from '../../../store/pricing/PricingActions';
import { PurchaseSelector } from '../../../store/purchase/PurchaseActions';
import { Line } from '../../styles/Dividers';
import { CostTableRows } from './CostComparisonExpTableRows';
import { SummaryTableRow } from './SummaryTableRow';

export const PlanSummaryTableForm: FunctionComponent = () => {
  const { purchase, hasTrial, hasOneTimeDiscount, planInterval, prices } = useAppStore((state) => ({
    purchase: state.purchase,
    hasTrial: PurchaseSelector.hasTrial(state.purchase),
    hasOneTimeDiscount: PricingSelector.hasOneTimeDiscount(state.pricing),
    planInterval: PLAN_INTERVALS[state.purchase.plan],
    prices: PricingSelector.prices(state),
  }));

  const { initialPlanPrice, ongoingPlanPrice, regularPlanPrice, trialPlanPrice, totalPriceToday } =
    prices || {};

  function getFinePrint(): string | undefined {
    if (!initialPlanPrice) {
      return undefined;
    }

    if (hasOneTimeDiscount) {
      return `Billed at ${initialPlanPrice} after ${purchase.trialPeriodDays} days
					then ${ongoingPlanPrice} every ${planInterval?.inText}`;
    }

    return `Billed at ${ongoingPlanPrice} every ${planInterval?.inText}`;
  }

  const finePrint = getFinePrint();

  return (
    <SummaryTableContainer>
      <SummaryTableRow
        description="Total today"
        badge
        price={totalPriceToday?.toString()}
        bold
        dataTest="todayPrice"
      />
      {/* unsure if we need this hasTrial boolean anymore? */}
      {hasTrial && (
        <>
          <SummaryTableRow
            dataTest="trialPrice"
            description={`${purchase.trialPeriodDays}-day ${PurchaseSelector.hasFreeTrial(purchase) ? 'free' : ''} trial`}
            price={trialPlanPrice?.toString()}
          />
          <Line color={Color.content.default} />
          <CostTableRows
            prices={prices}
            finePrint={finePrint}
            regularPlanPrice={regularPlanPrice}
            ongoingPlanPrice={ongoingPlanPrice}
            planIntervalText={planInterval?.inText}
          />
        </>
      )}
    </SummaryTableContainer>
  );
};

export const SummaryTableContainer = styled.div`
  border: 1px solid ${Color.decorative.default};
  border-radius: 8px;
  padding: ${({ theme }) => `${theme.spacing._24px}`};
  text-align: left;
`;
